/**
 * Build Information
 *
 * Provides access to build metadata injected at compile time by Vite.
 * Used for cache versioning and debugging.
 */

// These are injected by Vite's define plugin at build time
declare const __GIT_HASH__: string;
declare const __BUILD_TIME__: string;

export const getBuildInfo = () => {
  return {
    commitHash: __GIT_HASH__,
    buildTime: __BUILD_TIME__,
  };
};

export const getShortCommitHash = () => {
  return __GIT_HASH__;
};

export const getBuildTime = () => {
  return __BUILD_TIME__;
};
